var Emitter, UndoManager, assert;

Emitter = require('event-kit').Emitter;

assert = require('./util').assert;

module.exports = UndoManager = (function() {
  function UndoManager() {
    this.groupingLevel = 0;
    this.disabledLevel = 0;
    this.isRedoing = false;
    this.isUndoing = false;
    this.undoStack = [];
    this.redoStack = [];
    this.currentGroup = null;
    this.emitter = new Emitter();
    this.removeAllActions();
  }


  /*
  Section: Event Subscription
   */

  UndoManager.prototype.onWillUndo = function(callback) {
    return this.emitter.on('will-undo', callback);
  };

  UndoManager.prototype.onDidUndo = function(callback) {
    return this.emitter.on('did-undo', callback);
  };

  UndoManager.prototype.onWillRedo = function(callback) {
    return this.emitter.on('will-redo', callback);
  };

  UndoManager.prototype.onDidRedo = function(callback) {
    return this.emitter.on('did-redo', callback);
  };

  UndoManager.prototype.onDidOpenUndoGroup = function(callback) {
    return this.emitter.on('did-open-undo-group', callback);
  };

  UndoManager.prototype.onDidCloseUndoGroup = function(callback) {
    return this.emitter.on('did-close-undo-group', callback);
  };


  /*
  Section: Undo Grouping
   */

  UndoManager.prototype.beginUndoGrouping = function(metadata) {
    this.groupingLevel++;
    if (this.groupingLevel === 1) {
      this.currentGroup = [];
      this.currentGroup.metadata = metadata || {};
      return this.emitter.emit('did-open-undo-group', this.currentGroup);
    }
  };

  UndoManager.prototype.endUndoGrouping = function() {
    if (this.groupingLevel > 0) {
      this.groupingLevel--;
      if (this.groupingLevel === 0) {
        if (this.currentGroup.length > 0) {
          if (this.isUndoing) {
            this.redoStack.push(this.currentGroup);
          } else if (this.isRedoing) {
            this.undoStack.push(this.currentGroup);
          } else {
            this.undoStack.push(this.currentGroup);
            this.redoStack = [];
          }
        }
        this.emitter.emit('did-close-undo-group', this.currentGroup);
        return this.currentGroup = null;
      }
    }
  };


  /*
  Section: Undo Registration
   */

  UndoManager.prototype.isUndoRegistrationEnabled = function() {
    return this.disabledLevel === 0;
  };

  UndoManager.prototype.disableUndoRegistration = function() {
    return this.disabledLevel++;
  };

  UndoManager.prototype.enableUndoRegistration = function() {
    return this.disabledLevel--;
  };

  UndoManager.prototype.registerUndoOperation = function(operation) {
    if (!this.isUndoRegistrationEnabled()) {
      return;
    }
    this.beginUndoGrouping();
    this.currentGroup.unshift(operation);
    return this.endUndoGrouping();
  };

  UndoManager.prototype.setActionName = function(actionName) {
    return this.setUndoGroupMetadata('actionName', actionName.toLocaleString());
  };

  UndoManager.prototype.setUndoGroupMetadata = function(key, value) {
    var lastOrCurrentGoup, undoStack;
    undoStack = this.undoStack;
    lastOrCurrentGoup = this.currentGroup || undoStack[undoStack.length - 1];
    return lastOrCurrentGoup != null ? lastOrCurrentGoup.metadata[key] = value : void 0;
  };


  /*
  Section: Undo / Redo
   */

  UndoManager.prototype.canUndo = function() {
    return !this.isUndoing && !this.isRedoing && this.undoStack.length > 0;
  };

  UndoManager.prototype.canRedo = function() {
    return !this.isUndoing && !this.isRedoing && this.redoStack.length > 0;
  };

  UndoManager.prototype.undo = function(context) {
    assert(this.groupingLevel === 0, 'Unclosed grouping');
    assert(this.disabledLevel === 0, 'Unclosed disable');
    if (!this.canUndo()) {
      return;
    }
    this.endUndoGrouping();
    this.emitter.emit('will-undo');
    this.isUndoing = true;
    this.beginUndoGrouping(this.getUndoGroupMetadata());
    this.undoStack.pop().forEach(function(each) {
      if (each.performUndoOperation) {
        return each.performUndoOperation(context);
      } else {
        return each(context);
      }
    });
    this.endUndoGrouping();
    this.isUndoing = false;
    return this.emitter.emit('did-undo', this.getRedoGroupMetadata());
  };

  UndoManager.prototype.redo = function(context) {
    assert(this.groupingLevel === 0, 'Unclosed grouping');
    assert(this.disabledLevel === 0, 'Unclosed disable');
    if (!this.canRedo()) {
      return;
    }
    this.emitter.emit('will-redo');
    this.isRedoing = true;
    this.beginUndoGrouping(this.getRedoGroupMetadata());
    this.redoStack.pop().forEach(function(each) {
      if (each.performUndoOperation) {
        return each.performUndoOperation(context);
      } else {
        return each(context);
      }
    });
    this.endUndoGrouping();
    this.isRedoing = false;
    return this.emitter.emit('did-redo', this.getUndoGroupMetadata());
  };

  UndoManager.prototype.getUndoGroupMetadata = function() {
    var ref;
    return (ref = this.undoStack[this.undoStack.length - 1]) != null ? ref.metadata : void 0;
  };

  UndoManager.prototype.getRedoGroupMetadata = function() {
    var ref;
    return (ref = this.redoStack[this.redoStack.length - 1]) != null ? ref.metadata : void 0;
  };

  UndoManager.prototype.removeAllActions = function() {
    assert(this.groupingLevel === 0, 'Unclosed grouping');
    assert(this.disabledLevel === 0, 'Unclosed disable');
    this.undoStack = [];
    return this.redoStack = [];
  };

  return UndoManager;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/undo-manager.js
 ** module id = 203
 ** module chunks = 0
 **/